import Axios from "axios";
import Authorization from './auth';
import { executeCall } from "./utils";

const payments = (domain, resource, withAuth = true) => {
    const url = `${domain}/${resource}`;
    const getHeaders = () => withAuth ? Authorization() : {};

    return {
        clientHistory: () => executeCall(() => Axios.get(`${url}/client-history`, { headers: getHeaders() })),
        therapistHistory: () => executeCall(() => Axios.get(`${url}/therapist-history`, { headers: getHeaders() })),
        employeeSessions: () => executeCall(() => Axios.get(`${url}/employee-sessions`, { headers: getHeaders() })),
        therapistPayouts: () => executeCall(() => Axios.get(`${url}/therapist-payouts`, { headers: getHeaders() })),
    };
};

export default payments;
